export const DEFAULT_CONFIG = {
  authService: window.Config ? window.Config.authService : undefined,
  branding: window.Config ? window.Config.branding : undefined,
  adminService: window.Config ? window.Config.apiGateway : undefined,
  assuranceAppsService: window.Config ? window.Config.apiGateway : undefined,
  assuranceQueryService: window.Config ? window.Config.apiGateway : undefined,
  assuranceAdrService: window.Config ? window.Config.apiGateway : undefined,
  assuranceMdmService: window.Config ? window.Config.apiGateway : undefined,
  assuranceAlertConfigService: window.Config ? window.Config.apiGateway : undefined,
  assurancePreferenceService: window.Config ? window.Config.apiGateway : undefined,
  dashboardService: window.Config ? window.Config.apiGateway : undefined,
  loggingService: window.Config ? window.Config.apiGateway : undefined,

  keycloakUrl: window.Config ? window.Config.keycloak : undefined,
  keycloakClient: window.Config ? window.Config.keycloakClient : undefined,
  keycloakDefaultRealm: window.Config ? window.Config.keycloakDefaultRealm : undefined,

  passwordMinimumLength: window.Config ? window.Config.passwordMinimumLength : 8
};
